import _get from 'lodash/get'

/* @ngInject */
export default class EmulatorProximityController {
    constructor(
        EventEmitter,
        $scope,
        $state,
        $timeout,
    ) {
        this.EventEmitter = EventEmitter;
        this.$scope = $scope;
        this.$state = $state;
        this.$timeout = $timeout;
    }

    $onInit() {
        this.event = {
            objectPresent: {
                state: _get(this.device, 'reported.objectPresent.state', 'NOT_PRESENT')
            }
        }
    }

    get prettyState() {
        if (this.event.objectPresent.state === "NOT_PRESENT") {
            return "Open";
        }
        if (this.event.objectPresent.state === "PRESENT") {
            return "Closed";
        }
        return "";
    }

    sendObjectPresentEvent() {
        this.onPublishEvent(
            this.EventEmitter({
                event: this.event
            })
        )
    }
}